/** @format */

import React from 'react';
import {ThrownErrorHandler} from './loggly_error_handler';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {error: false, errorComponent: false};
    }

    componentDidCatch(error) {
        // Display fallback UI
        this.setState({error: true});
        // You can also log the error to an error reporting service
        ThrownErrorHandler(error);
    }

    render() {
        if (this.state.error) {
            if (this.state.errorComponent) {
                const Component = this.state.errorComponent;
                return <Component />;
            }

            return (
                <div className="d-flex align-items-center justify-content-center">
                    <div className="alert alert-danger">
                        <div style={{fontSize: '22px'}}>Oh Beans. 💩💩💩💩💩💩💩💩</div>
                        <div className="mt-2">Please submit as a bug!</div>
                        <div className="mt-2">
                            Please describe the last 2 or 3 things you were doing before
                            encountering this error. You are the best!
                        </div>
                        <div className="mt-2">{new Date().toString()}</div>
                    </div>
                </div>
            );
        }
        return this.props.children;
    }
}

const withErrorBoundary = ComponentContainer => {
    return class extends React.Component {
        static defaultProps = {
            ErrorBoundaryComponent: props => (
                <div className="p-2">
                    I had an error. It is not your fault. Please reload the page.
                    <div>{props.message}</div>
                </div>
            )
        };
        constructor(props) {
            super(props);
            this.state = {
                hasBoundaryError: false,
                message: ''
            };
        }

        componentDidCatch(error) {
            if (error.name === 'TypeError') {
                console.log(JSON.stringify(this.props));
            }

            // Display fallback UI
            this.setState({hasBoundaryError: true, message: error.toString()});
            // You can also log the error to an error reporting service
            ThrownErrorHandler(error);
        }

        render() {
            if (this.state.hasBoundaryError) {
                const ErrorBoundaryComponent = this.props.ErrorBoundaryComponent;
                return <ErrorBoundaryComponent {...this.state} />;
            }

            return <ComponentContainer {...this.props} />;
        }
    };
};

ErrorBoundary.displayName = 'ErrorBoundary';

export default ErrorBoundary;

export {withErrorBoundary};
